import React, { useEffect, useRef, useState } from "react";
import DocAccessibilityForm from "../../components/DocAccessibilityForm";
import DocList from "../../components/DocAccessList";
import HelperAccordion from "../../components/helperAccordion";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";
import nclude from '../../assets/nclude-color.svg';
import dashboard from '../../assets/dashboard-img.svg';
import { makeAuthenticatedGet } from "../../utils/fetchUtils";

function DashBoard() {
  const mainRef = useRef<HTMLHeadingElement>(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/login");
    }
    document.title = "Home - Nclude Portal";
  }, [navigate]);

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="DashBoard" />
        <div className="doc-container" role="main" tabIndex={-1} id="main-content">
          <section className="landing-page" aria-labelledby="dashboard-heading">
            <h1 className="display-title" id="dashboard-heading" ref={mainRef}>Dashboard</h1>
            <div className="content-container dashboard-container">
              <img src={dashboard} alt="NClude Dashboard Illustration" style={{width: '12.5rem'}}/>
              <h2 className="dashboard-brand-heading">
                NClude
              </h2>
              <p className="display-7">
                Welcome to <strong>NClude.AI</strong>, your comprehensive portal for information
                and accessibility services. Explore our content and media
                accessibility conversion services, job recommendations, career
                insights based on successful professionals with disabilities,
                accessible content library, and more.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default DashBoard;
